module.exports = __webpack_public_path__ + "img/bgimg_blue.c4e5a7fb.png";